import { TransactionBaseDto } from "../transactions/transaction-base.dto";
import { FinancialTransactionForTransactionMatch } from "../../types/transactionMatch";

/**
 * DTO for financial transaction in transaction match context.
 * Only includes scalar fields - entity relation not needed (entityId is sufficient).
 */
export class TransactionMatchFinancialTransactionDto extends TransactionBaseDto {
    static deserialize(
        dto: TransactionMatchFinancialTransactionDto,
    ): FinancialTransactionForTransactionMatch {
        return {
            ...dto,
            ...TransactionBaseDto.deserialize(dto),
        };
    }

    constructor(transaction: FinancialTransactionForTransactionMatch) {
        super(transaction);
    }
}
